import { Link, useLocation } from "react-router-dom";
import { UserPlus, HeartHandshake } from "lucide-react";
import { DONATE_URL } from "@/lib/links";

export const MobileActionBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="mobile-action-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-[90] flex border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]"
    >
      <Link
        to="/join"
        data-testid="mobile-apply-button"
        className="flex-1 flex items-center justify-center gap-2 bg-[#0A1128] text-white py-3.5 uppercase tracking-[0.15em] text-xs font-bold active:scale-[0.98] transition-transform duration-150"
      >
        <UserPlus className="w-4 h-4" /> Newsletter
      </Link>
      <a
        href={DONATE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-donate-button"
        className="flex-1 flex items-center justify-center gap-2 bg-[#D90429] text-white py-3.5 uppercase tracking-[0.15em] text-xs font-bold active:scale-[0.98] transition-transform duration-150"
      >
        <HeartHandshake className="w-4 h-4" /> Donate
      </a>
    </div>
  );
};
